// extracted by mini-css-extract-plugin
module.exports = {"oneImageContainer":"image-block-module--oneImageContainer--1DxLd","multiImageContainer":"image-block-module--multiImageContainer--AmWgy"};